export default "/images/5c00e067084582bf0a540965bb8e40d7.avif";